import ImageTileClass, * as ImageTileModule from './../../node_modules/ol/source/ImageTile.js';

class ImageTile extends ImageTileClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageTileModule) {
    if (key !== "default") {
        ImageTile[key] = ImageTileModule[key];
    }
}

export default ImageTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/ImageTile.js';